/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GuildTypes = "GUILD" | "NETWORK" | "%future added value";
export type UnauthenticatedHomeScreen_query = {
    readonly nodeBySlugId: {
        readonly upcomingEvents?: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly " $fragmentRefs": FragmentRefs<"EventItemNew_event">;
                };
            }>;
        } | undefined;
        readonly pastEvents?: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly " $fragmentRefs": FragmentRefs<"EventItemNew_event">;
                };
            }>;
        } | undefined;
        readonly upcomingPresentations?: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly " $fragmentRefs": FragmentRefs<"PresentationItem_presentation">;
                };
            }>;
        } | undefined;
        readonly pastPresentations?: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly " $fragmentRefs": FragmentRefs<"PresentationItem_presentation">;
                };
            }>;
        } | undefined;
        readonly " $fragmentRefs": FragmentRefs<"GuildCard_guild">;
    } | null;
    readonly rankedGuilds: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly name: string;
                readonly slugId: string;
                readonly type: GuildTypes | null;
                readonly " $fragmentRefs": FragmentRefs<"GuildPrimaryPhoto_guild" | "GuildCard_guild">;
            };
            readonly cursor: string;
        }>;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"HomeScreenPresentationsCard_query" | "EventItemNew_query">;
    readonly " $refType": "UnauthenticatedHomeScreen_query";
};
export type UnauthenticatedHomeScreen_query$data = UnauthenticatedHomeScreen_query;
export type UnauthenticatedHomeScreen_query$key = {
    readonly " $data"?: UnauthenticatedHomeScreen_query$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"UnauthenticatedHomeScreen_query">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v1 = {
  "kind": "Literal",
  "name": "timeSelection",
  "value": "UPCOMING"
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EventsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EventItemNew_event"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PresentationsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Presentation",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PresentationItem_presentation"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v4 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "GuildCard_guild"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "highlightedGuildSlug"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "UnauthenticatedHomeScreen_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "highlightedGuildSlug"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "nodeBySlugId",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "upcomingEvents",
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Literal",
                  "name": "orderBy",
                  "value": [
                    "START_AT_ASC",
                    "ID_ASC"
                  ]
                },
                (v1/*: any*/)
              ],
              "concreteType": "EventsConnection",
              "kind": "LinkedField",
              "name": "eventsByTimeSelection",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": "eventsByTimeSelection(first:1,orderBy:[\"START_AT_ASC\",\"ID_ASC\"],timeSelection:\"UPCOMING\")"
            },
            {
              "alias": "pastEvents",
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Literal",
                  "name": "orderBy",
                  "value": [
                    "START_AT_DESC",
                    "ID_ASC"
                  ]
                },
                {
                  "kind": "Literal",
                  "name": "timeSelection",
                  "value": "PAST"
                }
              ],
              "concreteType": "EventsConnection",
              "kind": "LinkedField",
              "name": "eventsByTimeSelection",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": "eventsByTimeSelection(first:1,orderBy:[\"START_AT_DESC\",\"ID_ASC\"],timeSelection:\"PAST\")"
            },
            {
              "alias": "upcomingPresentations",
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Literal",
                  "name": "orderBy",
                  "value": [
                    "CREATED_AT_ASC",
                    "ID_ASC"
                  ]
                },
                (v1/*: any*/)
              ],
              "concreteType": "PresentationsConnection",
              "kind": "LinkedField",
              "name": "presentationsByEventTimeSelection",
              "plural": false,
              "selections": (v3/*: any*/),
              "storageKey": "presentationsByEventTimeSelection(first:1,orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"],timeSelection:\"UPCOMING\")"
            },
            {
              "alias": "pastPresentations",
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Literal",
                  "name": "orderBy",
                  "value": [
                    "CREATED_AT_DESC",
                    "ID_ASC"
                  ]
                },
                {
                  "kind": "Literal",
                  "name": "timeSelection",
                  "value": "OTHER"
                }
              ],
              "concreteType": "PresentationsConnection",
              "kind": "LinkedField",
              "name": "presentationsByEventTimeSelection",
              "plural": false,
              "selections": (v3/*: any*/),
              "storageKey": "presentationsByEventTimeSelection(first:1,orderBy:[\"CREATED_AT_DESC\",\"ID_ASC\"],timeSelection:\"OTHER\")"
            },
            (v4/*: any*/)
          ],
          "type": "Guild",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 5
        },
        {
          "kind": "Literal",
          "name": "guildType",
          "value": "GUILD"
        }
      ],
      "concreteType": "GuildsConnection",
      "kind": "LinkedField",
      "name": "rankedGuilds",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GuildsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Guild",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slugId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "GuildPrimaryPhoto_guild"
                },
                (v4/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "rankedGuilds(first:5,guildType:\"GUILD\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HomeScreenPresentationsCard_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventItemNew_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();
(node as any).hash = '6516b97978da6b42ffd920892e1d424d';
export default node;
